import {Action} from "@ngrx/store";

export const TOGGLE_TOUR_SECTION: string = '[tourSection] Toggle Tour Section';

export class ToggleTourSection implements Action {
  readonly type: string = TOGGLE_TOUR_SECTION;
  constructor(public payload?: boolean) {}
}

export type TourSectionAction = ToggleTourSection;
